module.exports = __webpack_public_path__ + "static/media/snow_privatization_en.4017c6c8.md";